import React from 'react';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import Name from 'reactApp/ui/Name/Name';

import { FileDirection } from '../FileDirection/FileDirection';

const getShareAccess = (weblink: string) => `Доступ ${weblink ? 'открыт' : 'закрыт'}`;

const getFileName = (name: string, ext?: string, fullName?: boolean) => (
    <Name name={name} extension={ext} truncate={!fullName} disableEllipsis={fullName} />
);

const getFileDirection = (direction: string[]) => <FileDirection direction={direction} />;

const closeFileInfoModal = () => closePopupHelper(popupNames.MOBILE_FILE_INFO_MODAL);

const closeViewerModal = () => closePopupHelper(popupNames.MOBILE_VIEWER);

export { getShareAccess, getFileName, getFileDirection, closeFileInfoModal, closeViewerModal };
